import { CAROUSEL_CONSTANTS } from '../constants.js';

// Custom hook for carousel navigation
var useCarouselNavigation = function useCarouselNavigation(carouselApi) {
  var scrollPrev = function scrollPrev() {
    carouselApi === null || carouselApi === void 0 || carouselApi.scrollPrev();
  };
  var scrollNext = function scrollNext() {
    carouselApi === null || carouselApi === void 0 || carouselApi.scrollNext();
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === CAROUSEL_CONSTANTS.KEYBOARD_KEYS.ARROW_LEFT) {
      event.preventDefault();
      scrollPrev();
    } else if (event.key === CAROUSEL_CONSTANTS.KEYBOARD_KEYS.ARROW_RIGHT) {
      event.preventDefault();
      scrollNext();
    }
  };
  return {
    scrollPrev: scrollPrev,
    scrollNext: scrollNext,
    handleKeyDown: handleKeyDown
  };
};

export { useCarouselNavigation };
//# sourceMappingURL=useCarouselNavigation.js.map
